import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class FileUtils {
    constructor() {}


    public getSizeInMegaBytes(file: File) {
        return file ? file.size / 1048576 : 0;
    }

    public getSizeInKiloBytes(file: File) {
        return file ? file.size / 1024 : 0;
    }

    public getFileExtension(file: File) {
        return file ? file.type.split('/')[1] : null;
    }
}